export default __webpack_public_path__ + "static/media/successIcon.07fb7b7e.svg";